import Vue from "vue";

export default {
  fetchProfiles(state, profiles) {
    state.profiles.list = profiles;
    if (profiles.length && !state.profiles.activeProfileId)
      state.profiles.activeProfileId = profiles[0]._id;
  },
  activeProfileId(state, id) {
    state.profiles.activeProfileId = id;
  },
  removeProfile(state, id) {
    state.profiles.list = state.profiles.list.filter(
      profile => profile.id !== id
    );
  },
  updateProfile(state, profile) {
    if (!profile) return;
    const index = state.profiles.list.findIndex(item => profile.id === item.id);
    if (index < 0) return;
    Vue.set(state.profiles.list, index, profile);
  }
};
